<div class="globalDialog-ft">
    <ul class="hList hList_spread mix-hList_inlineBlock{{#if loading}} requestIsProcessing{{/if}}">
        <li><a href="" class="link js-action--cancel">cancel</a></li>
        <li><a href="" class="btn js-action--confirm">{{label}}</a></li>
    </ul>
</div>
